import React from 'react'
import { Users } from 'lucide-react'
import { PlaceholderPage } from '@/components/PlaceholderPage'

export const UsagePerCustomerPage: React.FC = () => (
  <PlaceholderPage
    icon={Users}
    titleKey="business.usagePerCustomerTitle"
    descriptionKey="business.usagePerCustomerDescription"
  />
)
